export const HeaderData = [
  {
    menu: "Home",
    link: "/",
  },
  {
    menu: "About Us",
    link: "/about",
  },

  {
    menu: "Services ",
    link: "#",
    submenu: true,
    subMenuitem: [
      {
        subItem: "Corporate travel",
        linkL: "/corporate-travel",
      },

      {
        subItem: "Travel consulting",
        linkL: "/travel-consulting",
      },
      {
        subItem: "Religous travel",
        linkL: "/religous-travel",
      },
      {
        subItem: "Visa",
        linkL: "/visa",
      },
    ],
  },

  {
    menu: "Hajj ",
    link: "#",
    submenu: true,
    subMenuitem: [
      {
        subItem: "Category 'A' ",
        linkL: "#",
        subMenuActive: true,
        subItems: [
          {
            item: "Package-1  (22 Days)",
            link: "/hajj/package-1",
          },
          {
            item: "Package-2  (17/18 Days)",
            link: "/hajj/package-2",
          },
          {
            item: "Package-3  (17 Days)",
            link: "/hajj/package-3",
          },
          {
            item: "Package-4 (14/15 Days)",
            link: "/hajj/package-4",
          },
          {
            item: "Package-5 (14 Days)",
            link: "/hajj/package-5",
          },
          {
            item: "Package-6 (14 Days)",
            link: "/hajj/package-6",
          },
          {
            item: "Package-7 (14 Days)",
            link: "/hajj/package-7",
          },
          {
            item: "Package-8 (10/11 Days)",
            link: "/hajj/package-8",
          },
        ],
      },
      {
        subItem: "Category 'B' ",
        linkL: "#",
        subMenuActive: true,
        subItems: [
          {
            item: "Package-1  (22 Days)",
            link: "/hajj/package1B",
          },
          {
            item: "Package-2  (17/18 Days)",
            link: "/hajj/package2B",
          },
          {
            item: "Package-3  (17 Days)",
            link: "/hajj/package3B",
          },
          {
            item: "Package-4 (14/15 Days)",
            link: "/hajj/package4B",
          },
          {
            item: "Package-5 (14 Days)",
            link: "/hajj/package5B",
          },
        
        ],
      },
      {
        subItem: "All Media",
        linkL: "#",
        subMenuActive: true,
        subItems: [
          {
            item: "Images 2024",
            link: "/hajj-media",
          },
          // {
          //   item: "Video 2024",
          //   link: "/hajj-videos",
          // },
        ],
      },
    ],
  },
  {
    menu: "Umrah ",
    link: "#",
    submenu: true,
    subMenuitem: [
      {
        subItem: "Umrah Package",
        linkL: "/umrah-packages",
        subMenuActive: true,
        subItems: [
          {
            item: "Economy  (14 Nights / 15 Days)",
            link: "/package1",
          },
          {
            item: "Economy Plus  (14 Nights/15 Days)",
            link: "/package2",
          },
          {
            item: "Package-3  (15 Days)",
            link: "/package3",
          },]
      },

      {
        subItem: "Media",
        linkL: "#",
        subMenuActive: true,
        subItems: [
          {
            item: "Images 2024",
            link: "/media",
          },
          // {
          //   item: "Video 2024",
          //   link: "/videos",
          // },
        ],
      },
    ],
  },
  //  {
  //     menu:"Page",
  //     link:"/#",
  //     submenu:true,
  //   subMenuitem:[
  //      {
  //          subItem:"About",
  //          linkL:"/about",
  //          subMenuActive:false,
  //      },

  //      {
  //          subItem:"Team",
  //          linkL:"/tour-guids",
  //          subMenuActive:false,
  //      },

  //      {
  //          subItem:"Testimonials",
  //          linkL:"/testimonials",
  //          subMenuActive:false,
  //      },

  //      {
  //          subItem:"FAQ",
  //          linkL:"/faqs",
  //          subMenuActive:false,
  //      },
  //      {
  //          subItem:"Booking Confirmation",
  //          linkL:"/booking-confirmation",
  //          subMenuActive:false,
  //      },

  //      {
  //          subItem:" Become Expert",
  //          linkL:"/become-expert",
  //          subMenuActive:false,
  //      },
  //      {
  //          subItem:"User Pages",
  //          linkL:"/#",
  //          subMenuActive:true,
  //          subItems:[
  //             {
  //                 item:"Login",
  //                 link:"/login"
  //             },
  //             {
  //                 item:"Register",
  //                 link:"/register"
  //             },
  //             {
  //                 item:"Forget Password",
  //                 link:"/forget-password"
  //             },
  //             {
  //                 item:"Verify OTP",
  //                 link:"/verifyOTP"
  //             },
  //             {
  //                 item:"Reset Password",
  //                 link:"/reset-password"
  //             },

  //          ]
  //      },
  //      {
  //         subItem:"Privacy Policy",
  //         linkL:"/privacy-policy",
  //         subMenuActive:false,
  //     },
  //     {
  //         subItem:"404 Error",
  //         linkL:"*",
  //         subMenuActive:false,
  //     },

  //     ]
  //  },
  //  {
  //     menu:"News",
  //     link:"/#",
  //     submenu:true,
  //   subMenuitem:[
  //      {
  //          subItem:"News",
  //          linkL:"/news",
  //          subMenuActive:false,
  //      },
  //      {
  //          subItem:"News Details",
  //          linkL:"/news-details",
  //          subMenuActive:false,
  //      },

  //     ]
  //  },
  {
    menu: "FAQs",
    link: "/faq",
  },
  {
    menu: "Contact",
    link: "/contact",
  },
];
